/* eslint-disable max-len */
export const NET_ERR =
  'A network error caused the media download to fail part-way.';
export const MED_ERR =
  'The media could not be loaded, either because the server or network failed or be cause the format is not supported.';
export const PLAY_ERR =
  'The media playback was aborted due to a corruption problem or because the media used features your browser did not support.';
export const MED_TYPE_ERR = 'No compatible source was found for this media.';
export const CR_ERR =
  'The media is encrypted and we do not have the keys to decrypt it.';
export const ERR =
  'This modal can be closed by pressing the Escape key or activating the close button.';
export const SET_ERR = 'restore all settings to the default values';
export const DIA_ERR =
  'Beginning of dialog window. Escape will cancel and close the window.';
